import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexGDAHero.scss';
import CustomImage from '../CustomImage';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';

const AmexGDAHero = ({
  baseRequestUrl, heroData, isGdaMember, printContent, Analytics, setScrollForDirMenu,
}) => {
  const {
    heroHeadline,
    heroBlurb,
    heroMessage,
    heroImg,
    heroImgAlt,
    heroHeadlineNonGda,
    heroBlurbNonGda,
    heroMessageNonGdaCta,
    heroMessageNonGdaCtaHref,
    heroMessageNonGdaQuestion,
    heroMessageNonGdaLinkHref,
    heroMessageNonGdaLinkText,
    heroMessageNonGdaMessage,
    headerTextImg,
  } = heroData;
  let heroHeadlineDisplay = '';
  let heroBlurbDisplay = '';
  let heroMessageDisplay = '';
  let heroMessageDisplayLinkText = '';
  let heroMessageDisplayMessage = '';
  if (isGdaMember) {
    heroHeadlineDisplay = printContent(heroHeadline, 'heroHeadline');
    heroBlurbDisplay = printContent(heroBlurb, 'heroBlurb', true);
    heroMessageDisplay = heroMessage;
  } else {
    heroHeadlineDisplay = printContent(heroHeadlineNonGda, 'heroHeadlineNonGda');
    heroBlurbDisplay = heroBlurbNonGda;
    heroMessageDisplay = heroMessageNonGdaQuestion;
    heroMessageDisplayLinkText = printContent(heroMessageNonGdaLinkText, 'heroMessageNonGdaLinkText');
    heroMessageDisplayMessage = printContent(heroMessageNonGdaMessage, 'heroMessageNonGdaMessage');
  }

  const sanitizedHeroHeadlineDisplay = sanitizeString(heroHeadlineDisplay);
  const sanitizedHeroBlurbDisplay = sanitizeString(heroBlurbDisplay);

  const trackFindOutHowCTA = () => {
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, { action_name: 'Banner - Find Out How Click' });
  };
  const trackUnlockAccessCTA = () => {
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, { action_name: 'Banner - Unlock Access Click' });
  };

  const handleUnlockAccessCTA = async () => {
    await setScrollForDirMenu(heroMessageNonGdaLinkHref);
    trackFindOutHowCTA();
  };

  return (
    <section className="GDA__section GDA__section--hero" id="hero">
      <div className="GDA__Hero">
        <div className="GDA__Hero__image">
          <CustomImage imageName={heroImg} alt={heroImgAlt} baseRequestUrl={baseRequestUrl} />
        </div>
        <div className="GDA__Hero__content">
          <div className="GDA__Hero__content--inner-container">
            <CustomImage
              key={headerTextImg}
              imageName={headerTextImg}
              className="GDA__Hero__body-logo"
              baseRequestUrl={baseRequestUrl}
              fileType="svg"
            />
            <h1
              className="GDA__Hero__content--heading"
              dangerouslySetInnerHTML={{
                __html: sanitizedHeroHeadlineDisplay,
              }}
            />
            {heroBlurbDisplay && (
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizedHeroBlurbDisplay,
                }}
              />
            )}
            {heroMessageDisplay && <p className="GDA__Hero__content_bold">{heroMessageDisplay}</p>}
            {!isGdaMember
              && (
                <>
                  {heroMessageNonGdaCta && (
                  <Link
                    href={window?.location?.href?.split('#')[0] + heroMessageNonGdaCtaHref}
                    variant="gda-primary"
                    className="GDA__Hero__non-member-cta"
                    onContextMenu={trackFindOutHowCTA}
                    onClick={trackFindOutHowCTA}
                  >
                    {heroMessageNonGdaCta}
                  </Link>
                  )}
                  <p className="GDA__Hero__non-member-display-message">
                    {heroMessageDisplayMessage}
                    &nbsp;
                    <Link
                      variant="no-style"
                      className="GDA__Hero__login"
                      type="button"
                      href={window?.location?.href?.split('#')[0] + heroMessageNonGdaLinkHref}
                      onContextMenu={trackUnlockAccessCTA}
                      onClick={handleUnlockAccessCTA}
                    >
                      {heroMessageDisplayLinkText}
                    </Link>
                  </p>
                </>
              )}
          </div>
        </div>
      </div>
    </section>
  );
};

AmexGDAHero.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  printContent: PropTypes.func.isRequired,
  setScrollForDirMenu: PropTypes.func.isRequired,
  isGdaMember: PropTypes.bool.isRequired,
  heroData: PropTypes.shape({
    headerTextImg: PropTypes.string.isRequired,
    heroHeadline: PropTypes.string.isRequired,
    heroBlurb: PropTypes.string.isRequired,
    heroMessage: PropTypes.string.isRequired,
    heroImg: PropTypes.string.isRequired,
    heroImgAlt: PropTypes.string.isRequired,
    heroHeadlineNonGda: PropTypes.string.isRequired,
    heroBlurbNonGda: PropTypes.string.isRequired,
    heroMessageNonGdaQuestion: PropTypes.string.isRequired,
    heroMessageNonGdaCta: PropTypes.string,
    heroMessageNonGdaCtaHref: PropTypes.string,
    heroMessageNonGdaLinkHref: PropTypes.string.isRequired,
    heroMessageNonGdaLinkText: PropTypes.string.isRequired,
    heroMessageNonGdaMessage: PropTypes.string.isRequired,
  }).isRequired,
};

export default AmexGDAHero;
